// extracted by mini-css-extract-plugin
export default {"container":"StateAwareList_container__CDIxR"};